/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type WarningXSmallIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function WarningXSmallIcon(props: WarningXSmallIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      fill={"none"}
      viewBox={"0 0 12 12"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g clipPath={"url(#a)"}>
        <path
          fill={"currentColor"}
          fillRule={"evenodd"}
          d={
            "m7.111.646 4.737 8.54a1.2 1.2 0 0 1 .098.938 1.22 1.22 0 0 1-.612.73 1.3 1.3 0 0 1-.6.146h-9.47a1.3 1.3 0 0 1-.623-.158 1.25 1.25 0 0 1-.461-.439 1.21 1.21 0 0 1-.03-1.217L4.888.646c.16-.288.43-.501.751-.594.32-.094.666-.06.961.095.217.113.396.287.512.499M7 6V3a1 1 0 0 0-2 0v3a1 1 0 0 0 2 0M6 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
          }
          clipRule={"evenodd"}
        ></path>
      </g>

      <defs>
        <clipPath id={"a"}>
          <path fill={"currentColor"} d={"M0 0h12v12H0z"}></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default WarningXSmallIcon;
/* prettier-ignore-end */
